const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeppoLogo119X47(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "119px",
    height: "47px",
    viewBox: "0 0 9449 3508",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.04024,0,0,3.04024,-1319.38,-891.029)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.840602,0,0,0.849569,-61.8248,-104.809)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 957.737,
    cy: 1148.25,
    rx: 317.832,
    ry: 314.477,
    style: {
      fill: "none",
      stroke: "rgb(255,220,0)",
      strokeWidth: "97.3px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.840602,0,0,0.849569,1182.82,-104.809)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 957.737,
    cy: 1148.25,
    rx: 317.832,
    ry: 314.477,
    style: {
      fill: "none",
      stroke: "rgb(0,84,159)",
      strokeWidth: "97.3px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.840602,0,0,0.849569,1805.14,-104.809)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 957.737,
    cy: 1148.25,
    rx: 317.832,
    ry: 314.477,
    style: {
      fill: "none",
      stroke: "rgb(0,84,159)",
      strokeWidth: "97.3px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.840602,0,0,0.849569,2427.46,-104.809)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 957.737,
    cy: 1148.25,
    rx: 317.832,
    ry: 314.477,
    style: {
      fill: "none",
      stroke: "rgb(214,0,5)",
      strokeWidth: "97.3px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.785419,-0.00443091,0.0042669,0.81561,427.032,-295.437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.349,774.289L54.79,1429.41",
    style: {
      fill: "none",
      stroke: "rgb(255,220,0)",
      strokeWidth: "102.72px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.553486,0.557276,-0.572949,-0.569399,2028.08,1471.56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.349,774.289L54.79,1429.41",
    style: {
      fill: "none",
      stroke: "rgb(255,220,0)",
      strokeWidth: "103.23px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.553486,0.557276,-0.572949,-0.569399,3890.71,1471.56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.349,774.289L54.79,1429.41",
    style: {
      fill: "none",
      stroke: "rgb(214,0,5)",
      strokeWidth: "103.23px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.785419,-0.00443091,0.0042669,0.81561,1672.05,239.72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.349,774.289L54.79,1429.41",
    style: {
      fill: "none",
      stroke: "rgb(0,84,159)",
      strokeWidth: "102.72px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.785419,-0.00443091,0.0042669,0.81561,2293.81,239.72)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.349,774.289L54.79,1429.41",
    style: {
      fill: "none",
      stroke: "rgb(0,84,159)",
      strokeWidth: "102.72px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.565786,0.563137,-0.530336,-0.53283,2262.93,1235.49)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M474.375,830.579L474.375,833.51C291.057,833.51 142.449,991.31 142.449,1185.97C142.449,1239.43 153.682,1290.12 173.777,1335.54C226.801,1455.37 341.526,1538.42 474.375,1538.42C657.57,1538.42 806.302,1380.49 806.302,1185.97C806.302,1092.49 771.331,1002.84 709.083,936.742L711.034,934.67C773.8,1001.32 809.061,1091.71 809.061,1185.97C809.061,1382.11 659.094,1541.35 474.375,1541.35C289.657,1541.35 139.689,1382.11 139.689,1185.97C139.689,989.691 289.533,830.579 474.375,830.579Z",
    style: {
      fill: "none",
      stroke: "rgb(255,220,0)",
      strokeWidth: "106.05px"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeppoLogo119X47);
export default __webpack_public_path__ + "static/media/beppo-logo-119x47.f6e5e9b14b1b5581d28daa3747825ac2.svg";
export { ForwardRef as ReactComponent };